<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
<!--                <div class="col-12">-->
<!--                    <ValidationProvider name="user_id" rules="required" v-slot="{ errors }">-->
<!--                        <b-form-group :label="$t('user')">-->
<!--                            <PersonsAutoComplete v-model="form.user_id"-->
<!--                                                 :returnType="'id'"  :validate-error="errors[0]"/>-->
<!--                        </b-form-group>-->
<!--                    </ValidationProvider>-->
<!--                </div>-->
<!--                <div class="col-12">-->
<!--                    <ValidationProvider name="type" rules="required" v-slot="{ valid, errors }">-->
<!--                        <b-form-group :label="$t('user_type')">-->
<!--                            <parameter-selectbox code="microsoft_team_group_user_types" v-model="form.type" :validate-error="errors[0]"/>-->
<!--                        </b-form-group>-->
<!--                    </ValidationProvider>-->
<!--                </div>-->
                <div class="col-12">
                    <ValidationProvider name="role" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('roles')">
                            <parameter-selectbox code="microsoft_team_group_roles" v-model="form.role" :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button
                @click="updateForm"
                type="button"
                variant="primary"
                class="btn-lg mr-2">
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    import MicrosoftTeamsGroupUsersServices from "@/services/MicrosoftTeamsGroupUsersServices";
    import PersonsAutoComplete from "@/components/interactive-fields/PersonsAutoComplete.vue";

    export default {
        props:{
            formId:{}
        },
        components: {
            PersonsAutoComplete,
            ValidationProvider,
            ValidationObserver,
        },
        data() {
            return {
                formLoading: false,
                form: {},
            }
        },
        watch: {
            formId: function (val) {
                this.get(val)
            }
        },
         created() {
             this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                MicrosoftTeamsGroupUsersServices.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                })
                                .catch((error) => {
                                    if (error.data.message) {
                                        this.$toast.error(this.$t("api." + error.data.message));
                                    }
                                }).finally(()=>{
                    this.formLoading = false;
                });
            },
            async updateForm() {
                if(this.checkPermission('microsoftteamgroupuser_update')) {
                    const isValid = await this.$refs.formModalValidate.validate();
                    if (isValid && this.formId) {
                        this.formLoading=true;
                        MicrosoftTeamsGroupUsersServices.update(this.formId, this.form)
                                        .then((response) => {
                                            this.formLoading = false;
                                            this.$toast.success(this.$t("api." + response.data.message));
                                            this.$emit("updateFormSuccess")
                                        })
                                        .catch((error) => {
                                            this.showErrors(error, this.$refs.formModalValidate)
                                        }).finally(() => {
                            this.formLoading = false;
                        })
                    }
                } else {
                    this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
                }
            }
        }
    }
</script>
